<template>
  <div class="table-wrapper">
    <h2 id="proSummaryTitle" v-if="title">{{ title }}</h2>
    <div style="position: relative; float: right; margin: 0px 0px -10px 0px">
      <el-dropdown
        trigger="click"
        @command="
          (command) => {
            this.$emit('handleTableCommands', { command: command, ref: `proSummary_${title}`, csvName: `proSummary_${title}_table`, headers: [], excludeHeaders: ['Details'] })
          }
        "
      >
        <span class="el-dropdown-link">
          <i title="table actions" class="mdi mdi-dots-horizontal" style="font-size: 20px; cursor: pointer"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="download">Download</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div :ref="`proSummary_${title}`">
      <table class="hiaTable">
        <thead>
          <tr>
            <th style="width: 190px"></th>
            <th>
              Total Codes
              <el-tooltip effect="dark" content="Combined accuracy rate for CM, EM, CPT and Modifier codes" placement="top">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </th>
            <th>ICD-10 CM Codes</th>
            <th>EM Codes</th>
            <th>CPT Codes</th>
            <th>Modifier Codes</th>
          </tr>
        </thead>
        <template v-if="item.totalRecords">
          <tr style="background-color: #fafafa">
            <td class="strong titleCol">Total Reviewed</td>

            <td>{{ item.totalCodesReviewed }}</td>
            <td>{{ item.dxTotalReviewed }}</td>
            <td>{{ item.emTotalReviewed }}</td>
            <td>{{ item.cptTotalReviewed }}</td>
            <td>{{ item.modTotalReviewed }}</td>
          </tr>

          <tr>
            <td class="strong titleCol">Total Recommendations</td>
            <td>{{ item.totalCodesRecommended }}</td>
            <td>{{ item.dxTotalRec }}</td>
            <td>{{ item.emTotalRec }}</td>
            <td>{{ item.cptTotalRec }}</td>
            <td>{{ item.modTotalRec }}</td>
          </tr>

          <tr>
            <td>&nbsp;</td>
          </tr>

          <tr style="background-color: #fafafa">
            <td class="strong titleCol">No Recommendations</td>
            <td>{{ item.totalCodesNoRec }}</td>
            <td>{{ item.dxNoRec }}</td>
            <td>{{ item.emNoRec }}</td>
            <td>{{ item.cptNoRec }}</td>
            <td>{{ item.modNoRec }}</td>
          </tr>

          <tr>
            <td class="strong titleCol">Additions</td>
            <td>{{ item.totalCodesAdditions }}</td>
            <td>{{ item.dxAdditions }}</td>
            <td>{{ item.emAdditions }}</td>
            <td>{{ item.cptAdditions }}</td>
            <td>{{ item.modAdditions }}</td>
          </tr>

          <tr style="background-color: #fafafa">
            <td class="strong titleCol">Deletions</td>
            <td>{{ item.totalCodesDeletions }}</td>
            <td>{{ item.dxDeletions }}</td>
            <td>{{ item.emDeletions }}</td>
            <td>{{ item.cptDeletions }}</td>
            <td>{{ item.modDeletions }}</td>
          </tr>

          <tr>
            <td class="strong titleCol">Revisions</td>
            <td>{{ item.totalCodesRev }}</td>
            <td>{{ item.dxRevisions }}</td>
            <td>{{ item.emRevisions }}</td>
            <td>{{ item.cptRevisions }}</td>
            <td>{{ item.modRevisions }}</td>
          </tr>

          <tr style="background-color: #fafafa">
            <td class="strong titleCol">Accuracy Rate</td>
            <td>{{ !item.totalCodesReviewed ? 'N/A' : formatPercentage(item.totalCodes) }}</td>
            <td>{{ !item.dxTotalReviewed ? 'N/A' : formatPercentage(item.cmCodes) }}</td>
            <td>{{ !item.emTotalReviewed ? 'N/A' : formatPercentage(item.emCodes) }}</td>
            <td>{{ !item.cptTotalReviewed ? 'N/A' : formatPercentage(item.cptCodes) }}</td>
            <td>{{ !item.modTotalReviewed ? 'N/A' : formatPercentage(item.modCodes) }}</td>
          </tr>
        </template>
      </table>

      <table style="margin-top: 30px" class="hiaTable">
        <thead>
          <tr>
            <th>Records with RVU Change</th>
            <th>Potential Increases</th>
            <th># Increases</th>
            <th>Potential Decreases</th>
            <th># Decreases</th>
            <th>Net RVU Impact</th>
          </tr>
        </thead>
        <tr v-if="item.totalRecords">
          <td>
            {{ !isNaN(item.rvuIncRecords) && !isNaN(item.rvuDecRecords) ? item.rvuIncRecords + item.rvuDecRecords : null }}
          </td>
          <td :class="`${item.rvuInc < 0 ? 'negative' : ''}`">{{ item.rvuInc }}</td>
          <td>{{ item.rvuIncRecords }}</td>
          <td :class="`${item.rvuDec < 0 ? 'negative' : ''}`">{{ item.rvuDec }}</td>
          <td>{{ item.rvuDecRecords }}</td>
          <td :class="`${item.rvuDiff < 0 ? 'negative' : ''}`">{{ item.rvuDiff }}</td>
        </tr>
        <tr v-else>
          <td colspan="6" style="opacity: 0.8">No RVU Data to Display</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import money from '@/mixins/money'
  export default {
    name: 'PROBasicSummary',
    props: ['item', 'title'],
    mixins: [money],
    data: function () {
      return {}
    },
    methods: {
      formatPercentage(value) {
        return `${(value * 100).toFixed(2)}%`
      }
    }
  }
</script>

<style scoped>
  table {
    border-spacing: 0px;
    border-collapse: collapse;
    table-layout: fixed;
  }

  th {
    color: #909399;
    font-weight: 600;
  }

  td,
  th {
    margin: 0px;
    padding: 10px 6px 10px 6px;
    vertical-align: top;
    font-size: 12px;
    text-align: center;
  }

  thead {
    text-align: left !important;
    padding-top: 5px;
  }

  h2 {
    margin: 20px 0px 20px 0px;
    font-size: 1.5rem;
    border-bottom: 1px solid #b4bccc;
    padding-bottom: 5px;
  }

  .titleCol {
    text-align: left !important;
  }

  .hiaTable tr td {
    text-align: right;
  }
</style>
